import http from "../../http";
import { CentroCusto } from "./entities/CentroCusto";

const actions = {
  deletar: async (state, { id }) => {
    try {
      await http.delete(`apiv2/cost-centers/${id}`, {
        id: id,
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  criar: async (state, { unidadeID, codigo, descricao, conta }) => {
    try {
      await http.post(`apiv2/vendors/${unidadeID}/cost-centers`, {
        name: descricao,
        code: codigo,
        owner_id: unidadeID,
        conta: conta,
      });
    } catch (error) {
      console.log(error);
    }
  },

  listar: async (state, { paginacao }) => {
    try {
      let params = {};
      if (paginacao) {
        params.per_page = paginacao.rowsPerPage;
        params.page = paginacao.page;
      }
      let resposta = await http.get(`apiv2/cost-centers`, { params });

      resposta = resposta.data;

      let listaCentrosCusto = [];
      resposta.results.data.forEach((centroCustoDTO) => {
        listaCentrosCusto.push(
          new CentroCusto({
            id: centroCustoDTO.id,
            codigo: centroCustoDTO.code,
            nome: centroCustoDTO.name,
            unidade: centroCustoDTO.vendor.name,
            dataCriacao: centroCustoDTO.created_at,
          })
        );
      });

      paginacao.page = resposta.results.current_page;
      paginacao.rowsPerPage = resposta.results.per_page;
      paginacao.rowsNumber = resposta.results.total;

      return {
        listaCentrosCusto,
        paginacao,
      };
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
};

export const centroCusto = {
  namespaced: true,
  actions,
};
